import { PANEL_WIDTH_IN_MM } from "shared/utils/standard-product";

export const useStandardProductAmountCalculator = (
  widthMM: number,
  heightMM: number
) => {
  let amount;

  if (heightMM >= 1350 && heightMM <= 2700)
    amount = Math.ceil(widthMM / PANEL_WIDTH_IN_MM);
  else if (heightMM < 1350) amount = Math.ceil(widthMM / PANEL_WIDTH_IN_MM / 2);
  else if (heightMM > 2700)
    amount = Math.ceil(
      widthMM / 600 + (((heightMM - 2700) / 1000) * (widthMM / 1000)) / 1.65
    );

  return amount;
};
